const uploadPerformance = function() {
  if (window.performance && window.Owl) {
    try {
      var timing = window.performance.timing.navigationStart
      window.Owl.addPoint({
          position: 1,
          duration: new Date() - timing
      });
      window.Owl.sendPoints()
      console.log('loading end time: ', new Date() - timing)
    } catch (e) {
      console.error(e)
    }
  }
}

export default uploadPerformance



// WEBPACK FOOTER //
// ./src/libs/owl-performance.js